// extracted by mini-css-extract-plugin
export default {"title":"jCx9V"};